import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M3 12h18","key":"svg-1"}]]

const IconCircleHalfVertical = createReactComponent('outline', 'circle-half-vertical', 'CircleHalfVertical', __iconNode);

export default IconCircleHalfVertical;